import { render, staticRenderFns } from "./KeybeEmojiPicker.vue?vue&type=template&id=6e4ed0ac&scoped=true&"
import script from "./KeybeEmojiPicker.vue?vue&type=script&lang=ts&"
export * from "./KeybeEmojiPicker.vue?vue&type=script&lang=ts&"
import style0 from "./KeybeEmojiPicker.vue?vue&type=style&index=0&id=6e4ed0ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4ed0ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VExpandTransition,VIcon})
